// extracted by mini-css-extract-plugin
export default {"label":"Reports_PersonalizationSummary_label__h-Z2u"};